/**
 * The route NAMES here are also the keys of the header data
 * (src/components/main-header/main-data-header.js) - MainHeader reads the current route name
 * and shows the data stored under the same key, so no props are needed.
 *
 * The two children have no component of their own: they are nested under `analysis` so the
 * sidebar item stays highlighted, and Analysis.vue decides what to show from the route name
 * (it renders RequestsAnalysis.vue / UsersAnalysis.vue itself).
 */
export default [
  {
    path: '/analysis',
    name: 'analysis',
    component: () => import('@/views/analysis/Analysis.vue'),
    meta: {
      title: 'Analysis - System Gulftic',
      requiresAuth: true,
    },
    children: [
      {
        path: 'requests',
        name: 'requests-analysis',
        meta: {
          title: 'Requests Analysis - System Gulftic',
          requiresAuth: true,
        },
      },
      {
        path: 'users',
        name: 'users-analysis',
        meta: {
          title: 'Users Analysis - System Gulftic',
          requiresAuth: true,
        },
      },
    ],
  },
]
